import { safeJson } from "src/app/helpers/Index";
import { faPencil, faPeopleGroup, faTrash } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FilterMatchMode } from "primereact/api";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { FileUpload } from "primereact/fileupload";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import React from "react";
import { ResizeImage } from "src/app/helpers/ResizeImage";
import { Col, Nav, Row } from "react-bootstrap";
import { Navigate } from "react-router-dom";
import { Sponsor } from "src/app/interfaces/Index";
import { FileService, SponsorService } from "src/app/services/Index";
import { colours } from "src/app/Styles";
import { environment } from "src/environments/environment";
import "./AdminSponsors.css";

type Props = {};
type State = {
	isLoading: boolean;
	filters1: any;
	globalFilter: string;
	masterItems: Sponsor[];
	items: Sponsor[];
	selectedItem: Sponsor;
	selectedItems: Sponsor[];
	showDeleteModal: boolean;
	showDeleteSelectionModal: boolean;
	showItemInfoModal: boolean;
	showPlayers: boolean;
	submitted: boolean;
	viewMode: string;
};

export class AdminSponsors extends React.Component<Props, State> {
	dt: any;	
	toast: any;
	itemName: string = "Sponsor";
	itemNamePlural: string = "Sponsors";

	constructor(props: Props) {
		super(props);
		this.state = {isLoading: false, filters1: {"global": { value: null, matchMode: FilterMatchMode.CONTAINS }}, globalFilter: "", masterItems: [], selectedItem: new Sponsor(), selectedItems: [], items: [], showDeleteModal: false, showDeleteSelectionModal: false, showItemInfoModal: false, showPlayers:false, submitted: false, viewMode: "tiles"};
	}

	categoryChange(e: any) {
		let selectedItem = {...this.state.selectedItem};
		// selectedItem.type = e.value;
		this.setState({selectedItem});
	}

	componentDidMount() {
		this.getItems();
	}

	deleteItemFooter() {
		return (
			<>
				<Button className="p-button-text" icon="pi pi-times" label="No" onClick={() => this.setState({showDeleteModal: false})}></Button>
				<Button className="p-button-text" icon="pi pi-check" label="Yes" onClick={(data) => this.deleteItemConfirm(data)}></Button>
			</>
		);
	}

	deleteItemsFooter() {
		return (
			<>
				<Button className="p-button-text" icon="pi pi-times" label="No" onClick={() => this.setState({showDeleteSelectionModal: false})}></Button>
				<Button className="p-button-text" icon="pi pi-check" label="Yes" onClick={() => this.deleteSelectedItemConfirm()}></Button>
			</>
		);
	}

	async deleteItemConfirm(rowData: any) {
		const res = await SponsorService.deleteSingleById(this.state.selectedItem.id);
		if (!res.ok) {
			this.toast.show({closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!"});
		} else {
			this.toast.show({closable: false, detail: this.state.selectedItem.name + " has been deleted", life: 5000, severity: "warn", summary: "Sponsor deleted!"});
		}
		this.getItems();
		this.setState({showDeleteModal: false});
	}

	deleteSelectedItemConfirm() {}

	itemInfoFooter() {
			return (
			<>
				<Button className="p-button-text" icon="pi pi-times" label="Cancel" onClick={() => this.setState({selectedItem: new Sponsor(), showItemInfoModal: false})}></Button>
				<Button className="p-button-text" icon="pi pi-check" label="Save" onClick={() => this.saveItem()}></Button>
			</>
			);
	}

	globalFilterChange(e: any) {
		let value = ""
		if (e !== ""){
			value = e.target.value;
			let newData = this.state.masterItems.filter(function(item){
				return item.name?.toLowerCase().includes(value.toLowerCase());
			 });
			 this.setState({items:newData});
		} else this.setState({items:this.state.masterItems});
		this.setState({globalFilter:value});    
	}

	async getItems() {
		this.setState({isLoading: true});
		const res = await safeJson(SponsorService.getAll());
		if (res && res.error) {
			this.toast.show({closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!"});
			this.setState({isLoading: false});
		}
		this.setState({isLoading: false, items: res, masterItems:res});
	}

	inputChange(e: any, name: string) {
		const val = (e.target && e.target.value) || "";
		let selectedItem = new Sponsor({...this.state.selectedItem});
		// @ts-ignore // Required to be able to use a generic function to change the values
		selectedItem[name] = val;
		this.setState({selectedItem});
	}

	inputNumberChange(e: any, name: string) {
		const val = e.value || 0;
		let selectedItem = new Sponsor({...this.state.selectedItem});
		// @ts-ignore // Required to be able to use a generic function to change the values
		selectedItem[name] = val;
		this.setState({selectedItem});
	}

	render() {
		return (
			<>
				<Row>
					<Col>
						<div className="card" style={{paddingTop: "1.5rem"}}>
							<h5 style={{paddingBottom: "1rem", paddingLeft: "1.5rem"}}>{this.itemNamePlural}</h5>
							<Toolbar left={() => this.renderLeftToolbarButtons()} right={() => this.renderRightToolbarButtons()}></Toolbar>
							{this.state.viewMode === "tiles" && this.renderTiles()}
							{this.state.viewMode === "list" &&
							<DataTable loading={this.state.isLoading} onSelectionChange={(e) => this.setState({selectedItems: e.value})} ref={(el) => this.dt = el} scrollable scrollHeight="flex" selection={this.state.selectedItems} style={{height: "calc(100vh - 17.5rem)"}} value={this.state.items} sortField="name" sortOrder={1}>
								{/* <Column headerStyle={{width: 50}} selectionMode="multiple"></Column> */}
								<Column header="Image" body={(rowData: any) => <img alt={rowData.imageLight} className="product-image" src={`${rowData.imageLight}`} height="50"/>}></Column>
								<Column field="name" header="Name" sortable ></Column>
								<Column field="contactName" header="Contact Name" sortable ></Column>
								<Column style={{width: 75}} body={(rowData) => (
									<div className="actions">
										<Button onClick={() => this.setState({selectedItem: rowData, showItemInfoModal: true})} style={{backgroundColor: colours.graphs.positive, borderColor: colours.graphs.positive, height: 30, justifyContent: "center", margin: 2, padding: 0, width: 30}}>
											<FontAwesomeIcon icon={faPencil} style={{color: colours.white}}/>
										</Button>
										<Button onClick={() => this.setState({selectedItem: rowData, showDeleteModal: true})} style={{backgroundColor: colours.error, borderColor: colours.error, height: 30, justifyContent: "center", margin: 2, padding: 0, width: 30}}>
											<FontAwesomeIcon icon={faTrash} style={{color: colours.white}}/>
										</Button>
									</div>
								)}></Column>
							</DataTable>
							}
							<Dialog className="p-fluid" footer={() => this.itemInfoFooter()} header={this.itemName + " Details"} modal onHide={() => this.setState({ showItemInfoModal: false })} style={{ width: "75%" }} visible={this.state.showItemInfoModal}>
										<Row>
											<Col>
												<div className="field" style={{ marginBottom: 10 }}>
													<label htmlFor="imageLight" style={{ width: "100%" }}>Image (Light BG)</label>
													<img id="imageLight" src={this.state.selectedItem.imageLight} style={{ height: 50, marginBottom: 10, marginTop: 10 }}></img>
												</div>
										<FileUpload accept="image/*" auto customUpload name="imageLight" style={{marginBottom: 10}} uploadHandler={(data) => this.uploadImage(data, "imageLight")} mode="basic"></FileUpload>
											</Col>
											<Col>
												<div className="field" style={{ marginBottom: 10 }}>
													<label htmlFor="imageDark" style={{ width: "100%" }}>Image (Dark BG)</label>
													<img id="imageDark" src={this.state.selectedItem.imageDark} style={{ height: 50, marginBottom: 10, marginTop: 10 }}></img>
												</div>
										<FileUpload accept="image/*" auto customUpload name="imageDark" style={{marginBottom: 10}} uploadHandler={(data) => this.uploadImage(data, "imageDark")} mode="basic"></FileUpload>
											</Col>
											<Col>
												<div className="field" style={{ marginBottom: 10 }}>
													<label htmlFor="imagePartner" style={{ width: "100%" }}>Image (Partner)</label>
													<img id="imagePartner" src={this.state.selectedItem.imagePartner} style={{ height: 50, marginBottom: 10, marginTop: 10 }}></img>
												</div>
										<FileUpload accept="image/*" auto customUpload name="imagePartner" style={{marginBottom: 10}} uploadHandler={(data) => this.uploadImage(data, "imagePartner")} mode="basic"></FileUpload>
											</Col>
										</Row>
										<Row>
										<Col>
												<div className="field" style={{ marginBottom: 10 }}>
													<label htmlFor="name">Sponsor Name <span style={{color:"red"}}>*</span></label>
													<InputText id="name" value={this.state.selectedItem.name} onChange={(e) => this.inputChange(e, "name")}/>
												</div>
											</Col>
											<Col>
												<div className="field" style={{ marginBottom: 10 }}>
													<label htmlFor="contactName">Contact Name <span style={{color:"red"}}>*</span></label>
													<InputText id="contactName" value={this.state.selectedItem.contactName} onChange={(e) => this.inputChange(e, "contactName")}/>
												</div>
											</Col>
										</Row>
										<Row>
										<Col>
												<div className="field" style={{ marginBottom: 10 }}>
													<label htmlFor="contactEmail">Contact Email</label>
													<InputText id="contactEmail" value={this.state.selectedItem.contactEmail} onChange={(e) => this.inputChange(e, "contactEmail")}/>
												</div>
											</Col>
											<Col>
												<div className="field" style={{ marginBottom: 10 }}>
													<label htmlFor="contactNumber">Contact Number</label>
													<InputText id="contactNumber" value={this.state.selectedItem.contactNumber} onChange={(e) => this.inputChange(e, "contactNumber")}/>
												</div>
											</Col>
										</Row>
							</Dialog>
							<Dialog footer={() => this.deleteItemFooter()} header="Confirm" modal onHide={() => this.setState({showDeleteModal: false})} style={{width: 550}} visible={this.state.showDeleteModal}>
								<div className="align-items-center d-flex">
									<i className="pi pi-exclamation-triangle" style={{fontSize: "2rem", marginRight: 12}}/>
									<span>Are you sure you want to delete <b>{this.state.selectedItem.name}</b>? The sponsor will disappear from sponsor lists and dropdowns, but existing player and fixture links keep their history.</span>
								</div>
							</Dialog>
						</div>
					</Col>
				</Row>
				<Toast ref={(el) => this.toast = el}></Toast>
				{this.state.showPlayers && (
								<Navigate replace={true} to={`/${environment.build.adminRoute}/Sponsor-players/${this.state.selectedItem.id}`} />
				)}
			</>
		);
	}

	renderTiles() {
		return (
			<div className="sponsor-tiles">
				{(Array.isArray(this.state.items) ? this.state.items : []).map((sponsor, i) =>
					<div className="sponsor-tile" key={`sponsor-tile-${i}`} onClick={() => this.setState({selectedItem: sponsor, showItemInfoModal: true})}>
						<div className="sponsor-tile-logo">
							{(sponsor.imageDark || sponsor.imageLight)
								? <img alt={sponsor.name} loading="lazy" src={sponsor.imageDark || sponsor.imageLight}/>
								: <span className="sponsor-tile-initials">{(sponsor.name || "?").split(" ").map((w) => w[0]).join("").substring(0, 3).toUpperCase()}</span>
							}
						</div>
						<div className="sponsor-tile-name">{sponsor.name}</div>
						{sponsor.contactName && <div className="sponsor-tile-contact">{sponsor.contactName}</div>}
						<div className="sponsor-tile-actions">
							<Button onClick={(e) => { e.stopPropagation(); this.setState({selectedItem: sponsor, showItemInfoModal: true}); }} style={{backgroundColor: colours.graphs.positive, borderColor: colours.graphs.positive, height: 30, justifyContent: "center", padding: 0, width: 30}}>
								<FontAwesomeIcon icon={faPencil} style={{color: colours.white}}/>
							</Button>
							<Button onClick={(e) => { e.stopPropagation(); this.setState({selectedItem: sponsor, showDeleteModal: true}); }} style={{backgroundColor: colours.error, borderColor: colours.error, height: 30, justifyContent: "center", padding: 0, width: 30}}>
								<FontAwesomeIcon icon={faTrash} style={{color: colours.white}}/>
							</Button>
						</div>
					</div>
				)}
			</div>
		);
	}

	renderLeftToolbarButtons() {
		return (
			<>
				<Button icon="pi pi-plus" label="New" style={{backgroundColor: colours.graphs.positive, borderColor: colours.graphs.positive, marginRight: 10}} onClick={() => this.setState({selectedItem: new Sponsor(), showItemInfoModal: true})}></Button>
				<Button className={this.state.viewMode === "tiles" ? "" : "p-button-outlined"} icon="pi pi-th-large" label="Tiles" style={this.state.viewMode === "tiles" ? {backgroundColor: colours.primary, borderColor: colours.primary} : {}} onClick={() => this.setState({viewMode: "tiles"})}></Button>
				<Button className={this.state.viewMode === "list" ? "" : "p-button-outlined"} icon="pi pi-list" label="List" style={this.state.viewMode === "list" ? {backgroundColor: colours.primary, borderColor: colours.primary, marginLeft: 6} : {marginLeft: 6}} onClick={() => this.setState({viewMode: "list"})}></Button>
				{/* <Button disabled={!this.state.selectedItems || !this.state.selectedItems.length} icon="pi pi-trash" label="Delete" style={{backgroundColor: colours.graphs.negative, borderColor: colours.graphs.negative, marginRight: 10}} onClick={() => this.setState({showDeleteSelectionModal: true})}></Button> */}
			</>
		);
	}

	renderRightToolbarButtons() {
		return (
			<>
			<div className="flex justify-content-between">
                <Button type="button" icon="pi pi-filter-slash" label="Clear" className="p-button-outlined" onClick={()=>{this.globalFilterChange("")}} />
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText value={this.state.globalFilter} onChange={(e)=> {this.globalFilterChange(e)}} placeholder="Keyword Search" />
                </span>
            </div>
				<Button icon="pi pi-upload" label="Export" style={{backgroundColor: colours.buttons.export, borderColor: colours.buttons.export, marginLeft: 10}} onClick={() => this.dt?.exportCSV()}></Button>
			</>
		);
	}

	async saveItem() {
		this.setState({isLoading: true});
		if (this.state.selectedItem.id === -1 || this.state.selectedItem.id === undefined) { // Create new
			const res = await safeJson(SponsorService.createSingle(this.state.selectedItem));
			if (res && res.error) {
				this.toast.show({closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!"});
				this.setState({isLoading: false});
			}
			this.setState({isLoading: false, showItemInfoModal:false});
			this.toast.show({closable: false, detail: this.itemName + " has been created", life: 5000, severity: "success", summary: this.itemName + " created!"});
		} else { // Save existing
			const res = await safeJson(SponsorService.updateSingleById(this.state.selectedItem.id,this.state.selectedItem));
			if (res && res.error) {
				this.toast.show({closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!"});
				this.setState({isLoading: false});
			}
			this.setState({isLoading: false, showItemInfoModal:false});
			this.toast.show({closable: false, detail: this.itemName + " has been saved", life: 5000, severity: "success", summary: this.itemName + " saved!"});
		}
		this.getItems();
	}

	async uploadImage(data: any, property: string) {
		const containerName = "uploads";
		const uploadData = new FormData();
		uploadData.append("containerName", containerName);
		uploadData.append("files", await ResizeImage(data.files[0]));
		uploadData.append("mimeTypeKey", "Images");
		const response = await(await FileService.upload(uploadData)).json();
		let selectedItem = {...this.state.selectedItem};
		// @ts-ignore // Required to be able to change the values
		selectedItem[property] = `${environment.server.storageUrl}/${response[0].location}`;
		await this.setState({selectedItem});
	}
		
}